import serviceRequest from "utils/request";

const baseUrl = "/api/site";

export const getSiteForUser = () => {
	return serviceRequest({
		url: `${baseUrl}/get-site-for-user`,
		method: "get",
	});
};

export const getSiteForAdmin = () => {
	return serviceRequest({
		url: `${baseUrl}/get-site-for-admin`,
		method: "get",
	});
};

export const getUserBookingSite = (data) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-site-for-user`,
		method: "post",
		data,
	});
};
